export {useSSRSafeId} from '../../../src/ssr/SSRProvider';
